import { Box } from "@mui/material";
import i18next from "i18next";
import React, { useCallback, useEffect, useState } from "react";
import DataTable from "../../../../components/dataTable/DataTable";
import styles from "./vehicleTableSection.module.scss";
import _ from "lodash";
import TextBoxCompOne from "../../../../components/textBoxCompOne/TextBoxCompOne";
import StatusText from "../../../../components/statusText/StatusText";
import CustomPagination from "../../../../components/pagination/CustomPagination";
import { getStatusClassName } from "../../../../utils/commonFuntion";
import BulkActionMenu from "../../../../components/bulkActionMenu/bulkActionMenu";
import CustomSnackbar from "../../../../components/customSnackBar/CustomSnackbar";
import CustomModalDialog from "../../../../components/modal/CustomModalDialog";
import DeleteCertificate from "../deleteCertificateContent/DeleteCertificate";
import moment from "moment";
import {
  deleteVehicleCertificate,
  updateVehicleCertificate,
} from "../../../../services/APIService";
import { useApiErrorModalContext } from "../../../../errorHandling/ApiErrorModalContext";
import PropTypes from "prop-types";
import { TooltipWrapper } from "../../../Dealers/components/dealerTableSection/DealerTableSection";

const VehicleTableSection = (props) => {
  const {
    vehiclesList,
    snackBarMessage,
    openSnackbar,
    setOpenSnackbar,
    setSelectedVehicleNo,
    setSelectedDealerNo,
    setDetailsDrawerState,
    setVehicleDetailsDrawerState,
    selectionModel,
    setSelectionModal,
    bulkActionMenuFlag,
    setBulkActionMenuFlag,
    setSelectedVehicleDetails,
    refreshTable,
    pageNumber,
    totalRecords,
    pageSize,
    handlePageChange,
    handlePageSizeChange,
    sortModel,
    onSortChange,
    setSearchFlag,
  } = props;

  const [tableColumnData, setTableColumnData] = useState([]);
  const [tableHeader, setTableHeader] = useState([]);

  const [isShowModalFlag, setIsShowModalFlag] = useState(false);
  const { setApiErrorModalState } = useApiErrorModalContext();

  const handleDealerDelete = (certificateList, vehicleIds) => {
    deleteVehicleCertificate({
      vehicleIds: vehicleIds,
      certificateIds: certificateList,
    })
      .then((response) => {
        if (
          !_.isEmpty(_.get(response, "errorMessage", "")) ||
          _.get(response, "success", true) === false
        ) {
          _.set(response, "status", 200);

          setApiErrorModalState({ error: response });
        } else {
          setSelectionModal([]); //remove if not needed
          refreshTable();
          setIsShowModalFlag(false);
        }
      })
      .catch((err) => {
        setApiErrorModalState({ error: err });
      });
  };

  const handleDeleteCertificate = (selectedCertificate, certificateOption) => {
    let certificateList = Object.keys(_.pickBy(selectedCertificate));
    let certificateIds = certificateList.map((certifciate) => {
      if (certifciate === "Combined certificates") {
        return 100;
      } else {
        let selectedOption = certificateOption.filter(
          (option) => option.key === certifciate
        )[0];

        return selectedOption.value;
      }
    });
    handleDealerDelete(certificateIds, selectionModel);
  };

  const handleCertificateStatus = (vehicleId, status, certificate) => {
    setSearchFlag(true);
    let statusUpdate = status
      ? { certificate: certificate, status: true }
      : { certificate: certificate, status: false };

    updateVehicleCertificate({
      vehicleId: vehicleId,
      certificateStatus: statusUpdate,
    })
      .then((response) => {
        if (
          !_.isEmpty(_.get(response, "errorMessage", "")) ||
          _.get(response, "success", true) === false
        ) {
          _.set(response, "status", 200);

          setApiErrorModalState({ error: response });
          setSearchFlag(false);
        } else {
          refreshTable();
        }
      })
      .catch((err) => {
        setApiErrorModalState({ error: err });
      });
  };
  const onLicenceClick = useCallback(
    (licensePlateNo, data) => {
      document.getElementById("contentWrapper").scrollIntoView = function () {};
      setSelectedVehicleNo(licensePlateNo);
      setVehicleDetailsDrawerState(true);
      setSelectedVehicleDetails(data);
    },
    [
      setSelectedVehicleNo,
      setVehicleDetailsDrawerState,
      setSelectedVehicleDetails,
    ]
  );

  const handleCloseButtonClick = () => {
    setBulkActionMenuFlag(false);
  };
  const handleDeleteBtnClick = () => {
    setIsShowModalFlag(true);
  };

  const updateBulkActionFlag = (prevValue, currentValue) => {
    if (currentValue?.length >= 1) {
      if (!bulkActionMenuFlag) {
        // to avoid unwanted rendering
        setBulkActionMenuFlag(true);
      }
    } else if (currentValue?.length < 1) {
        if (bulkActionMenuFlag) {
          // to avoid unwanted rendering
          setBulkActionMenuFlag(false);
        }
      }
  };

  const onDealerClick = useCallback(
    (dealerNo) => {
      document.getElementById("contentWrapper").scrollIntoView = function () {};

      setSelectedDealerNo(dealerNo);
      setDetailsDrawerState(true);
    },
    [setDetailsDrawerState, setSelectedDealerNo]
  );

  useEffect(() => {
    const tableHeaderColumns = [
      {
        field: "licensePlateNo",
        headerName: i18next.t("License, VIN"),
        flex: 1.4,
        sortable: !_.isEmpty(vehiclesList),
        renderCell: (params) => (
          <TextBoxCompOne
            onheaderClick={() => {
              onLicenceClick(params.row?.licensePlateNo, params.row);
            }}
            headerTextStyle={styles.licenceColumn}
            headerText={params.row?.licensePlateNo.toUpperCase()}
            subText={`${params.row?.vin}`}
            subTextStyle={
              params.row?.licensePlateNo.length === 0
                ? styles.licenceColumn
                : styles.subText
            }
            onsubtextClick={
              params.row?.licensePlateNo.length === 0
                ? () => {
                    onLicenceClick(params.row?.licensePlateNo, params.row);
                  }
                : null
            }
          />
        ),
      },

      {
        field: "model",
        headerName: i18next.t("Make, Model"),
        flex: 1.4,
        sortable: !_.isEmpty(vehiclesList),
        renderCell: (params) => (
          <TextBoxCompOne
            headerText={`${params.row?.make}`}
            subText={`${i18next.t("Model")}: ${params.row?.model}`}
          />
        ),
      },
      {
        field: "dealerName",
        headerName: i18next.t("Dealer"),
        flex: 2.2,
        sortable: !_.isEmpty(vehiclesList),
        renderCell: (params) => (
          <TextBoxCompOne
            hasStar={params.row?.isDealerGroup}
            headerText={TooltipWrapper(
              params.row?.dealerName,
              styles.dealerNameColumn,
              45
            )}            
            headerTextStyle={styles.dealerNameColumn}
            onheaderClick={() => onDealerClick(params.row?.dealer_Id)}
          />
        ),
      },
      {
        field: "status_100OH",
        headerName: i18next.t("100% OH"),
        flex: 1.2,
        sortable: !_.isEmpty(vehiclesList),
        renderCell: (params) => (
          <StatusText
            defaultId={params.row?.vehicle_Id}
            defaultStatus={params.row?.status_100OH}
            title={params.row?.status_100OH}
            customClass={getStatusClassName(params.row?.status_100OH)}
            hasIcon={true}
            data-testid="100_OH"
            showPopover={true}
            list={2}
            onStatusChange={(id, status) =>
              handleCertificateStatus(id, status, "Status_100OH")
            }
          />
        ),
      },
      {
        field: "status_Checked_Go",
        headerName: i18next.t("BOV"),
        flex: 1.2,
        sortable: !_.isEmpty(vehiclesList),
        renderCell: (params) => (
          <StatusText
            defaultId={params.row?.vehicle_Id}
            defaultStatus={params.row?.status_Checked_Go}
            title={params.row?.status_Checked_Go}
            customClass={getStatusClassName(params.row?.status_Checked_Go)}
            hasIcon={true}
            data-testid="Checked_go"
            showPopover={true}
            list={2}
            onStatusChange={(id, status) =>
              handleCertificateStatus(id, status, "Status_Checked_Go")
            }
          />
        ),
      },
      {
        field: "status_Label3",
        headerName: i18next.t("BIT"),
        flex: 1.2,
        sortable: !_.isEmpty(vehiclesList),
        renderCell: (params) => (
          <StatusText
            defaultId={params.row?.vehicle_Id}
            defaultStatus={params.row?.status_Label3}
            title={params.row?.status_Label3}
            customClass={getStatusClassName(params.row?.status_Label3)}
            hasIcon={true}
            data-testid="label3"
            showPopover={true}
            list={2}
            onStatusChange={(id, status) =>
              handleCertificateStatus(id, status, "Status_Label3")
            }
          />
        ),
      },
      {
        field: "status_Label4",
        headerName: i18next.t("BOGAR"),
        flex: 1.2,
        sortable: !_.isEmpty(vehiclesList),
        renderCell: (params) => (
          <StatusText
            defaultId={params.row?.vehicle_Id}
            defaultStatus={params.row?.status_Label4}
            title={params.row?.status_Label4}
            customClass={getStatusClassName(params.row?.status_Label4)}
            hasIcon={true}
            data-testid="label4"
            showPopover={true}
            list={2}
            onStatusChange={(id, status) =>
              handleCertificateStatus(id, status, "Status_Label4")
            }
          />
        ),
      },
      {
        field: "status_Label5",
        headerName: i18next.t("Label5"),
        flex: 1.2,
        sortable: !_.isEmpty(vehiclesList),
        renderCell: (params) => (
          <StatusText
            defaultId={params.row?.vehicle_Id}
            defaultStatus={params.row?.status_Label5}
            title={params.row?.status_Label5}
            customClass={getStatusClassName(params.row?.status_Label5)}
            hasIcon={true}
            data-testid="label5"
            showPopover={true}
            list={2}
            onStatusChange={(id, status) =>
              handleCertificateStatus(id, status, "Status_Label5")
            }
          />
        ),
      },

      {
        field: "isActive",
        headerName: i18next.t("Adv. Status"),
        flex: 1.2,
        sortable: !_.isEmpty(vehiclesList),
        renderCell: (params) => (
          <Box className={styles.statusWraper}>
            {i18next.t(params.row?.isActive ? "Actief" : "Inactive")}
          </Box>
        ),
      },

      {
        field: "lastPost",
        sortable: !_.isEmpty(vehiclesList),

        headerName: (
          <Box className={styles.twoLineColumn}>
            {i18next.t("Laatste bericht")}
          </Box>
        ),
        flex: 1.2,
        renderCell: (params) => (
          <span className={styles.dateWrapper}>
            {params.row?.lastPost === null || params.row?.lastPost === undefined
              ? moment(params.row?.createdDate).format("DD-MM-YYYY")
              : moment(params.row?.lastPost).format("DD-MM-YYYY")}
          </span>
        ),
      },
    ];
    setTableHeader(tableHeaderColumns);

    setTableColumnData(vehiclesList);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [vehiclesList, onLicenceClick]);

  return (
    <Box
      className={styles.vehicleTableSectionWrapper}
      data-testid="vehicle-table"
    >
      <DataTable
        columns={tableHeader}
        rows={tableColumnData}
        isShowMessage={true}
        isShowTableWhenNoResult={true}
        disableColumnMenu={true}
        disableColumnFilter={true}
        hideFooter={true}
        isCheckboxSelection={true}
        disableRowSelectionOnClick={true}
        onRowSelectionModelChange={(newRowSelectionModel) => {
          setSelectionModal((prev) => {
            updateBulkActionFlag(prev, newRowSelectionModel);
            return newRowSelectionModel;
          });
        }}
        rowSelectionModel={selectionModel}
        onSortModelChange={(model) => onSortChange(model)}
        sortModel={sortModel}
      />
      <CustomSnackbar
        open={openSnackbar}
        message={snackBarMessage}
        setOpen={setOpenSnackbar}
      />

      {bulkActionMenuFlag && selectionModel.length > 0 ? (
        <BulkActionMenu
          btnlist={[
            {
              title: "Delete certificates",
              iconStyle: "delete",
              buttonType: "muibtn-menu-with-icon",
              customStyle: "deleteBtn",
              withIcon: true,
              handleClick: () => {
                handleDeleteBtnClick();
              },
            },
          ]}
          selectionModel={selectionModel}
          handleCloseButtonClick={handleCloseButtonClick}
        />
      ) : null}
      {isShowModalFlag ? (
        <CustomModalDialog
          title={i18next.t("Delete certificates")}
          isShow={isShowModalFlag}
          onClose={() => setIsShowModalFlag(false)}
          className={"modal-dialog"}
          isCloseButton={true}
          hasFooter={false}
        >
          <DeleteCertificate
            handleDelete={handleDeleteCertificate}
            handleCancel={() => setIsShowModalFlag(false)}
          />
        </CustomModalDialog>
      ) : (
        ""
      )}
      {!_.isEmpty(vehiclesList) && pageSize < totalRecords ? (
        <CustomPagination
          row={tableColumnData}
          paginationResult={{
            pageSize: pageSize,
            pageNumber: pageNumber,
            totalRecords: totalRecords,
          }}
          setCurrentPageNumber={handlePageChange}
          showRowPerPage={false}
          setCurrentPageSize={handlePageSizeChange}
        />
      ) : null}
    </Box>
  );
};
export default VehicleTableSection;

VehicleTableSection.propTypes = {
  vehiclesList: PropTypes.any,
  snackBarMessage: PropTypes.any,
  openSnackbar: PropTypes.any,
  setOpenSnackbar: PropTypes.any,
  setSelectedVehicleNo: PropTypes.any,
  setVehicleDetailsDrawerState: PropTypes.any,
  selectionModel: PropTypes.any,
  setSelectionModal: PropTypes.any,
  bulkActionMenuFlag: PropTypes.any,
  setBulkActionMenuFlag: PropTypes.any,
  setSelectedVehicleDetails: PropTypes.any,
  refreshTable: PropTypes.any,
  pageNumber: PropTypes.any,
  totalRecords: PropTypes.any,
  pageSize: PropTypes.any,
  handlePageChange: PropTypes.any,
  handlePageSizeChange: PropTypes.any,
  sortModel: PropTypes.any,
  onSortChange: PropTypes.any,
  setSearchFlag: PropTypes.any,
  setSelectedDealerNo: PropTypes.any,
  setDetailsDrawerState: PropTypes.any
};
